import { call, put } from 'redux-saga/effects';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';
import { requestAddComment, requestDeleteComment, requestEditComment, requestRestoreComment } from '../requests/comment';

export function* handleAddComment(action) {
    try {
        const { type, id, data, callback } = action.payload;
        const response = yield call(requestAddComment, type, id, data);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleEditComment(action) {
    try {
        const { type, id, commentId, data, callback } = action.payload;
        const response = yield call(requestEditComment, type, id, commentId, data);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleDeleteComment(action) {
    try {
        const { type, id, commentId, callback } = action.payload;
        const response = yield call(requestDeleteComment, type, id, commentId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleRestoreComment(action) {
    try {
        const { type, id, commentId, callback } = action.payload;
        const response = yield call(requestRestoreComment, type, id, commentId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}